module.exports = __webpack_public_path__ + "img/01.86d417b1.png";